import resolveConfig from "tailwindcss/resolveConfig";
import { STATIC_COLORS, COLORS } from "./colors";

// @ts-ignore
import tailwindConfig from "./tailwind.config";

const config = resolveConfig(tailwindConfig);
export type Config = ReturnType<typeof resolveConfig>;
export { STATIC_COLORS, COLORS };

export default config;
